export function customerMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      customerId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateCustomerId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateCustomerId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyCustomer(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      customerId: resource.objectId,
    })),
  };
}

export function customerMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, customerId: json.result.objectId},
  };
}